import React from "react";
import { fas } from "../../utils/icons";
import { Modal } from "antd";
import classNames from "classnames";
import PropTypes from "prop-types";
import * as classes from "./CustomModal.module.scss";
import { CustomIcon } from "../adaptors/CustomIcon";

export const CustomModal = (props) => {
  const { children, customClass, closeIcon, ...rest } = props;

  return (
    <Modal
      {...rest}
      wrapClassName={classNames(classes.customModal, customClass)}
      closeIcon={closeIcon}
    >
      {children}
    </Modal>
  );
};

CustomModal.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  visible: PropTypes.bool,
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
  children: PropTypes.node,
  width: PropTypes.node,
  centered: PropTypes.bool,
  customClass: PropTypes.string,
  footer: PropTypes.element,
  closeIcon: PropTypes.node,
};

CustomModal.defaultProps = {
  title: "",
  visible: false,
  onOk: () => {},
  onCancel: () => {},
  children: null,
  width: 568,
  centered: false,
  customClass: "",
  footer: null,
  closeIcon: <CustomIcon icon={fas.faTimes} />,
};
